import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewTipoCambio = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'tipo_cambio',
        name: 'Tipo Cambio',
        component: ViewTipoCambio,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router